import React from 'react';
import { Heading, Paragraph } from '@hungryroot/ramen';
import styles from './ControlTagTernaryItem.module.css';
import layoutStyles from '../../Page/layout.module.css';

interface ControlTagTernaryItemProps {
  Icon: React.ComponentType<{ className?: string }>;
  index: number;
  remark?: string | null;
  tagName: string;
  ternaryRating: React.ReactNode;
}

export function ControlTagTernaryItem({
  ternaryRating,
  tagName,
  Icon,
  index,
  remark,
}: ControlTagTernaryItemProps) {
  return (
    <div
      className={`${styles['container']} ${layoutStyles['slide-in']}`}
      style={{ animationDelay: `${0.05 * index + 0.5}s` }}
    >
      <div className={styles['info']}>
        <Icon className={styles['icon']} />
        <div className={styles['text']}>
          <Heading className={styles['tag-name']} variant="H5">
            {tagName}
          </Heading>
          <Paragraph className={styles['remark']}>{remark}</Paragraph>
        </div>
      </div>
      <div className={styles['rating-buttons']}>{ternaryRating}</div>
    </div>
  );
}
